import React from 'react';
import Clock from 'lucide-react/dist/esm/icons/clock.js';
import History from 'lucide-react/dist/esm/icons/history.js';
import { useTranslations } from '../../../contexts/TranslationContext';
import { useDrawsPage } from './DrawsPageContext';

export default function DrawsCalendar() {
  const { t } = useTranslations();
  const { activeTab, setActiveTab } = useDrawsPage();

  return (
    <div className="flex justify-center mb-8">
      <div className="inline-flex rounded-xl p-1 bg-white/10 dark:bg-gray-800/40 backdrop-blur-sm">
        <button
          onClick={() => setActiveTab('upcoming')}
          className={`px-8 py-3 rounded-lg font-semibold transition-all ${
            activeTab === 'upcoming'
              ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-lg'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          }`}
        >
          <div className="flex items-center gap-2">
            <Clock className="w-5 h-5" />
            <span>{t('draws.tab.upcoming')}</span>
          </div>
        </button>
        <button
          onClick={() => setActiveTab('past')}
          className={`px-8 py-3 rounded-lg font-semibold transition-all ${
            activeTab === 'past'
              ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-lg'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
          }`}
        >
          <div className="flex items-center gap-2">
            <History className="w-5 h-5" />
            <span>{t('draws.tab.past')}</span>
          </div>
        </button>
      </div>
    </div>
  );
}
